import { render, staticRenderFns } from "./modalExamenLaboratorio.vue?vue&type=template&id=3be8540c"
import script from "./modalExamenLaboratorio.vue?vue&type=script&lang=js"
export * from "./modalExamenLaboratorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports